import axios from 'axios'
import { BASEURL } from './api.variables'

const BASEPLACESURL = `${BASEURL}/places`
const POSTQUIZURL = (placeId, language) => `${BASEPLACESURL}/${placeId}/quiz?language=${language}`
const GETQUIZURL = (placeId, quizId) => `${BASEPLACESURL}/${placeId}/quiz/${quizId}`
const GETQUIZQRCODEURL = (placeId, quizId) => `${BASEURL}/admin/places/${placeId}/quiz/${quizId}/qrcode`
const POSTANSWERSURL = (placeId, quizId, language) =>
  `${BASEPLACESURL}/${placeId}/quiz/${quizId}/answers?language=${language}`
const UPDATEANSWERSURL = (placeId, quizId, answerId) => `${BASEPLACESURL}/${placeId}/quiz/${quizId}/answers/${answerId}`
const UPDATEANSWERSLANGUAGEURL = (placeId, quizId, answerId, languageId) =>
  `${BASEPLACESURL}/${placeId}/quiz/${quizId}/answers/${answerId}/languages/${languageId}`
const UPDATEQUIZURL = (placeId, quizId, id) => `${BASEPLACESURL}/${placeId}/quiz/${quizId}/languages/${id}`
const GETQUIZESURL = (limit, skip, language, placeId) => {
  let params = ''
  if (limit) {
    params += `limit=${limit}`
  }
  if (skip) {
    params += `&skip=${skip}`
  }
  if (language) {
    params += `&language=${language}`
  }
  return `${BASEPLACESURL}/${placeId}/quiz?${params}`
}

const headers = () => {
  return {
    Authorization: document.redecienciaToken ? `Bearer ${document.redecienciaToken}` : ''
  }
}

const GetQuizes = (limit = 50, skip = 0, language = 'pt', placeId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: GETQUIZESURL(limit, skip, language, placeId),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const DeleteQuiz = (placeId, quizId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'delete',
      url: `${BASEPLACESURL}/${placeId}/quiz/${quizId}`,
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const GetQuiz = (placeId, quizId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: GETQUIZURL(placeId, quizId),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const GetQuizQrCode = (placeId, quizId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: GETQUIZQRCODEURL(placeId, quizId),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const CreateQuiz = (data, placeId, quizId = null, language) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      data,
      url: POSTQUIZURL(placeId, quizId, language),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const TranslateQuiz = ({ placeId, id, data }) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      data,
      url: `${BASEPLACESURL}/${placeId}/quiz/${id}/languages`,
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const UpdateQuizTranslation = ({ placeId, quizId, id, data }) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'patch',
      data,
      url: `${BASEPLACESURL}/${placeId}/quiz/${quizId}/languages/${id}`,
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const DeleteQuizTranslation = ({ placeId, quizId, id }) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'delete',
      url: `${BASEPLACESURL}/${placeId}/quiz/${quizId}/languages/${id}`,
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const TranslateQuizAnswer = ({ placeId, quizId, id, data }) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      data,
      url: `${BASEPLACESURL}/${placeId}/quiz/${quizId}/answers/${id}/languages`,
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const UpdateQuizAnswerTranslation = ({ placeId, quizId, answerId, id, data }) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'patch',
      data,
      url: `${BASEPLACESURL}/${placeId}/quiz/${quizId}/answers/${answerId}/languages/${id}`,
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const DeleteQuizAnswerTranslation = ({ placeId, quizId, answerId, id }) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'delete',
      url: `${BASEPLACESURL}/${placeId}/quiz/${quizId}/answers/${answerId}/languages/${id}`,
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const CreateQuizAnswer = (data, placeId, quizId, language = 'pt') => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      data,
      url: POSTANSWERSURL(placeId, quizId, language),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const UpdateQuizAnswer = (data, placeId, quizId, answerId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'patch',
      data,
      url: UPDATEANSWERSURL(placeId, quizId, answerId),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const UpdateQuizAnswerLanguage = (data, placeId, quizId, answerId, languageId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'patch',
      data,
      url: UPDATEANSWERSLANGUAGEURL(placeId, quizId, answerId, languageId),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const UpdateQuiz = (data, placeId, quizId, id) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'patch',
      data,
      url: UPDATEQUIZURL(placeId, quizId, id),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const DeleteQuizAnswer = (placeId, quizId, answerId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'delete',
      url: UPDATEANSWERSURL(placeId, quizId, answerId),
      headers: headers(),
      crossDomain: true
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

export {
  CreateQuiz,
  GetQuizes,
  DeleteQuiz,
  GetQuiz,
  CreateQuizAnswer,
  UpdateQuizAnswer,
  DeleteQuizAnswer,
  UpdateQuiz,
  UpdateQuizAnswerLanguage,
  GetQuizQrCode,
  TranslateQuiz,
  TranslateQuizAnswer,
  DeleteQuizTranslation,
  UpdateQuizTranslation,
  UpdateQuizAnswerTranslation,
  DeleteQuizAnswerTranslation
}



// WEBPACK FOOTER //
// ./src/api/quiz.js